import React from 'react'
import { Button } from '../../core/Button/Button.jsx'
import { Link } from '../../core/Link/Link.jsx'
import PropTypes from 'prop-types'
import './cta.css'
import { joinClassList } from '../utilities/utilities.js'
import { ErrorBoundary } from 'react-error-boundary'
import { textAlignments } from '../statistics/statsConstants.js'
import { isProduction } from '../../utility/index.js'

const Cta = ({ ctaAlignment, displayInline = false, theme, ...props }) => {
  const ctaProps = props[0]
  const wrapperClasses = joinClassList([
    'Cta',
    'u-paddingTop8gu',
    displayInline ? 'u-flexInline' : '',
  ])

  const showLInk = ctaProps.linkType === 'link'
  const showSomething = ctaProps.text
  const reverseTheme =
    theme === 'reversed' || ctaProps.reversed ? 'reversed' : ''
  const linkType = {
    primaryBtn: 'primary',
    secondaryBtn: 'secondary',
    tertiaryBtn: 'tertiary',
    raspberryBtn: 'raspberry',
  }

  return showSomething ? (
    <div className={textAlignments[ctaAlignment]}>
      <div className={wrapperClasses}>
        {showLInk ? (
          <div>
            <Link
              theme={reverseTheme}
              text={ctaProps.text}
              target={ctaProps.target}
              href={ctaProps.link?.[0]?.linkHref}
              icon="chevron_right"
            />
          </div>
        ) : (
          <Button
            variant={linkType[ctaProps.linkType.trim()]}
            theme={reverseTheme}
            text={ctaProps.text}
            size="default"
            asAnchor={true}
          />
        )}
      </div>
    </div>
  ) : null
}
Cta.propTypes = {
  displayInline: PropTypes.oneOf(['true', 'false']),
}

export default function CtaErrorBoundary(props) {
  return (
    <ErrorBoundary
      fallbackRender={() =>
        !isProduction() ? <p>Error in CTA component</p> : null
      }
    >
      <Cta {...props}></Cta>
    </ErrorBoundary>
  )
}
